// extracted by mini-css-extract-plugin
export default {"head":"styles_head__dsunZ","avatar":"styles_avatar__lbxmf","text":"styles_text__vaxmi"};